/**
 * Author / reviewer entities used for Person schema on blog posts and reports.
 *
 * "Perceptica" is NOT a person: posts authored by the brand map to the sitewide
 * Organization node instead of emitting a fake Person.
 */

export type PostAuthor = {
  name: string;
  /** Profile URL (bio page or /about-us#team anchor). */
  url?: string;
  /** Authoritative profiles (LinkedIn etc.) for entity disambiguation. */
  sameAs?: string[];
  jobTitle?: string;
};

export const EDITORIAL_TEAM_NAME = "Perceptica Editorial Team";

const TEAM_ANCHOR = "https://perceptica.com/about-us#team";

/** Analysts who can be credited as post authors. */
export const AUTHORS: Record<string, PostAuthor> = {
  "veronika-svetoslavova": {
    name: "Veronika Svetoslavova",
    url: TEAM_ANCHOR,
    jobTitle: "Media Analyst",
  },
  "silvana-simitchiyska": {
    name: "Silvana Simitchiyska",
    url: TEAM_ANCHOR,
    jobTitle: "Media Analyst",
  },
  "natalia-hristoforova": {
    name: "Natalia Hristoforova",
    url: TEAM_ANCHOR,
    jobTitle: "Media Analyst",
  },
  "nikolay-kolev": {
    name: "Nikolay Kolev",
    url: TEAM_ANCHOR,
    jobTitle: "Media Analyst",
  },
};

/** Reviews and signs off every report and blog post. */
export const REVIEWER: PostAuthor = {
  name: "Peyo Georgiev",
  url: TEAM_ANCHOR,
  jobTitle: "Head of Research",
};

const BY_NAME: Record<string, PostAuthor> = Object.fromEntries(
  [...Object.values(AUTHORS), REVIEWER].map((a) => [a.name.toLowerCase(), a]),
);

/** Look up a known Person by display name. Returns undefined for the brand. */
export function findAuthor(name?: string): PostAuthor | undefined {
  if (!name) return undefined;
  return BY_NAME[name.trim().toLowerCase()];
}
